const authHeader = () => {
  const token = JSON.parse(localStorage.getItem("kafd-app-token") as any);
  const lang = JSON.parse(localStorage.getItem("lang") as any);

  if (token) {
    return {
      Authorization: `Bearer ${token}`,
      "content-language": lang,
    };
  }
};

export default authHeader;
